export const userMenuTexts = {
  logout: 'Logout',
}

export const topNavTexts = {
  bookingSearch: 'Booking search',
  knowledgeDatabase: 'Knowledge database',
}

export const mobileNavTexts = {
  menu: 'Menu',
}
